const PROJECT_V2_TYPE = 'rocky';

export const GET_SSN_RESULT_CONTENT = `${PROJECT_V2_TYPE}/get_ssn_result_content`;
export const UPDATE_SELECT_VERIFICATION = `${PROJECT_V2_TYPE}/update_select_verification`;